// extracted by mini-css-extract-plugin
module.exports = {"container":"LA-z","productName":"MA-z","modal":"NA-z","dimensions":"OA-z","recipientEmail":"PA-z","lowStock":"QA-z","recommendedFit":"RA-z","notRecommendedFit":"SA-z"};